module.exports = __webpack_public_path__ + "img/Header_Desktop_Logo.6edefc30.png";